/* eslint-disable no-param-reassign */
import axios from 'axios';
import cacheAxios from '../../util/cacheAxios';

const minWageAxios = axios.create();
const cache = new Map();
cacheAxios(minWageAxios, cache);
minWageAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/minwage';
      }, 500);
    }
  });

export default {
  state: {
    minWageCountries: [],
    minWages: [],
  },
  mutations: {
    setMinWages(state, wages) {
      state.minWages = wages;
    },
    setMinWageCountries(state, countries) {
      state.minWageCountries = countries;
    },
  },
  actions: {
    getMinWageCountries({
      commit,
    }) {
      minWageAxios.post('/aims/api/economy/minwageCountries')
        .then((res) => {
          if (res.data) {
            commit('setMinWageCountries', res.data);
          }
        });
    },
    getMinWage({
      commit,
    }, query) {
      return minWageAxios.post('/aims/api/economy/minwageByCountryArea',
          query, {
            cache: true,
            cacheKey: query,
          })
        .then((res) => {
          if (res.data) {
            commit('setMinWages', res.data);
          }
        });
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/minWageModule.js